<template>
    <el-dialog custom-class="hitchhiking-create" title="创建工单" :visible.sync="dialogVisible" width="600px"
        :before-close="handleClose" destroy-on-close :close-on-click-modal="false">
        <el-form :model="formData" :rules="rules" ref="formRef" label-width="100px">
            <el-form-item label="客诉类型" prop="categoryId">
                <el-cascader v-model="formData.categoryId" :options="workTypeList" :props="{
                    expandTrigger: 'hover',
                    value: 'id',
                    label: 'name'
                }" @change="handleChange" placeholder="请选择客诉类型" clearable />
            </el-form-item>

            <el-form-item label="紧急程度" prop="priority">
                <el-select v-model="formData.priority" placeholder="请选择">
                    <el-option v-for="item in $const.URGENCYLIST" :key="item.value" :label="item.label"
                        :value="item.value" />
                </el-select>
            </el-form-item>

            <el-form-item label="客诉描述" prop="complaintDesc">
                <el-input type="textarea" v-model="formData.complaintDesc" :maxlength="200" show-word-limit rows="4"
                    placeholder="简单描述乘客投诉内容" />
            </el-form-item>

            <el-form-item label="工单附件">
                <upload_pdfs :max="5" :multiple="true" accept=".png,.jpg,.jpeg"
                    :urls.sync="formData.complaintAttachment" @isUpLoad="isUpLoad"> </upload_pdfs>
            </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="loading">提 交</el-button>
        </div>
    </el-dialog>
</template>

<script>
import upload_pdfs from "@/components/pdf/upload_pdfs";
export default {
    name: 'HitchhikingCreate',
    components: {
        upload_pdfs
    },
    data() {
        return {
            loading: false,
            dialogVisible: false,
            orderId: null,
            organizationName: '',
            formData: {
                categoryId: [],
                priority: '',
                complaintDesc: '',
                complaintAttachment: [],
                categoryName: ""
            },
            fileList: [],
            rules: {
                categoryId: [
                    {
                        required: true,
                        message: '请选择客诉类型',
                        validator: (rule, value, callback) => {
                            if (!value || value.length < 2) {
                                callback(new Error('请选择完整的客诉类型'));
                            } else {
                                callback();
                            }
                        }
                    }
                ],
                priority: [
                    { required: true, message: '请选择紧急程度' }
                ],
                complaintDesc: [
                    { required: true, message: '请输入客诉描述' }
                ]
            }
        }
    },
    created() {
        this.mixinGetWorkType();
    },
    methods: {
        isUpLoad(isUpLoad) {
            this.loading = isUpLoad
        },
        // 客诉类型变更
        handleChange(value) {
            if (value.length > 1) {
                let parent = this.workTypeList.filter(item => item.id === value[0])[0];
                let children = parent.children.filter(item => item.id === value[1])[0];
                this.formData.priority = children.priority;
                this.formData.categoryName = parent.name + '/' + children.name;
            } else {
                this.formData.priority = '';
                this.formData.categoryName = '';
            }
        },
        // 显示弹窗
        show(orderId, organizationName) {
            this.orderId = orderId
            this.organizationName = organizationName
            this.dialogVisible = true
        },
        // 关闭弹窗
        handleClose() {
            this.$refs.formRef.resetFields()
            this.fileList = []
            this.dialogVisible = false
        },
        handleSubmit() {
            this.$refs.formRef.validate(async (valid) => {
                if (valid) {
                    this.loading = true
                    const url = "/api/v1/manage/hitchRide/work"
                    const params = {
                        orderId: this.orderId,
                        categoryId: this.formData.categoryId[1],
                        priority: this.formData.priority,
                        complaintDesc: this.formData.complaintDesc,
                        complaintAttachment: this.formData.complaintAttachment.map(item => item.url).join(','),
                        categoryName: this.formData.categoryName
                    }
                    let { code, data } = await this.$axios.post(url, params)
                    if (code === 1) {
                        this.$message.success('工单创建成功')
                        this.$router.push({
                            path: '/hitchRideWorkDetail',
                            query: {
                                id: data
                            }
                        })
                    }
                    this.loading = false
                }
            })
        },

    }
}
</script>

<style lang="less" scoped>

.dialog-footer {
    text-align: right;
}

.el-upload__tip {
    color: #909399;
    font-size: 12px;
    margin-top: 7px;
}
</style>
